import React from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from '../VisibilitySensor';

const beautifyText = (text) =>
  text.replace(/'/g, '’').replace(/\s([^\s<]+)\s*$/, '\u00A0$1');

const PrincipalCard = ({
  className,
  image,
  headline,
  htmlCopy,
  cardType,
  style,
}) => (
  <div className={`principal-card ${cardType} ${className}`} style={style}>
    <figure className="principal-card__image">
      <VisibilitySensor offset={{ top: 10 }}>
        {({ isVisible }) => (
          <img
            src={image.src}
            alt={image.alt}
            className={isVisible ? 'fadeInUp animated' : 'hidden'}
            style={{ animationDuration: '.5s' }}
          />
        )}
      </VisibilitySensor>
    </figure>
    <div className="principal-card__body">
      <h3
        className="fs-h3 mb-5 text-center"
        dangerouslySetInnerHTML={{ __html: beautifyText(headline) }}
      ></h3>
      <div dangerouslySetInnerHTML={{ __html: beautifyText(htmlCopy) }}></div>
    </div>
  </div>
);

PrincipalCard.defaultProps = {
  className: '',
  style: {},
  cardType: '',
  image: {
    src: '',
    alt: '',
  },
  headline: '',
  htmlCopy: '',
};

PrincipalCard.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  cardType: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
  }),
  headline: PropTypes.string,
  htmlCopy: PropTypes.string,
};

export default PrincipalCard;
